<template>
  <layout
    title="Buttons"
    >
    
    Rujuk fail <code>Zen/Buttons.vue</code>

    <w-divider class="my2" />

    <z-button
    save
    class="mr1"
    />

    <z-button
    save
    :nolabel="true"
    icon="fal fa-arrow-circle-down"
    class="mr1"
    />

    <z-button
    save
    icon="fal fa-arrow-circle-down"
    class="mr1"
    />

    <z-button
    save
    :loading="true"
    />

    <w-divider class="my2" />

    <z-button
    submit
    />

    <w-divider class="my2" />

    <z-button
    cancel
    />

    <w-divider class="my2" />

    <z-button
    reset
    />

    <w-divider class="my2" />

    <z-button
    search
    />

    <w-divider class="my2" />

    <z-button
    filter
    />

    <w-divider class="my2" />

    <div class="z-button-group">
    <z-button
    reset
    :nolabel="true"
    tile
    />

    <z-button
    cancel
    :nolabel="true"
    tile
    />

    <z-button
    save
    class="mr1"
    tile
    :loading="loading"
    @click="submit"
    />
    </div>

    <w-divider class="my2" />

    <div class="z-button-group">
    <z-button
    reset
    :nolabel="true"
    tile
    />

    <z-button
    cancel
    :nolabel="true"
    tile
    />

    <z-button
    submit
    class="mr1"
    tile
    :loading="loading"
    @click="submit"
    />
    </div>
    
    
  </layout>
</template>

<script>
export default {
  data() {
    return {
      loading: false
    }
  },
  methods: {
    submit (id) {
    this.loading = true
    setTimeout(() => (this.loading = false), 3000)
  }
  }
}
</script>
<style>
button:not([class=".w-button--icon"]) {
  width: 90px;
}
.z-button-group :first-child {
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
}
.z-button-group :last-child {
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
}
</style>